import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetOffersFromHistoryFailed, EGetOffersFromHistoryActionType } from './types';

export const getOffersFromHistoryFailed: () => TGetOffersFromHistoryFailed =
  actionGenerator<EGetOffersFromHistoryActionType.Failed>(EGetOffersFromHistoryActionType.Failed);
